import { render, staticRenderFns } from "./CadastroTipoArquivo.vue?vue&type=template&id=d070c792&"
import script from "./CadastroTipoArquivo.vue?vue&type=script&lang=js&"
export * from "./CadastroTipoArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports